/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WidgetClient } from '../models/WidgetClient';
import type { WidgetLoginPayload } from '../models/WidgetLoginPayload';
import type { WidgetLoginResponse } from '../models/WidgetLoginResponse';
import type { WidgetRequestLoginCodePayload } from '../models/WidgetRequestLoginCodePayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class WidgetAuthService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Request login code (widget)
     * Request a login code by email for the booking widget.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public widgetRequestLoginCode(
        requestBody: WidgetRequestLoginCodePayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/widget-auth/request-login-code',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public widgetAuthControllerOptionsRequestLoginCode(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/widget-auth/request-login-code',
        });
    }
    /**
     * Login via code (widget)
     * Exchange a login code for a short-lived widget bearer token.
     * @param requestBody
     * @returns WidgetLoginResponse
     * @throws ApiError
     */
    public widgetLogin(
        requestBody: WidgetLoginPayload,
    ): CancelablePromise<WidgetLoginResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/widget-auth/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public widgetAuthControllerOptionsLogin(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/widget-auth/login',
        });
    }
    /**
     * Get current widget client
     * Resolve the currently authenticated widget client from the bearer token.
     * @returns WidgetClient
     * @throws ApiError
     */
    public widgetWhoAmI(): CancelablePromise<WidgetClient> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/widget-auth/me',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public widgetAuthControllerOptionsMe(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/widget-auth/me',
        });
    }
}
